import { createFileRoute } from '@tanstack/react-router';
import { RequireRole } from '../components/RequireRole';
import { TicketsInbox } from '../features/tickets/TicketsInbox';

export const Route = createFileRoute('/tickets/')({
  component: () => (
    <RequireRole allow={['admin']}>
      <TicketsInbox />
    </RequireRole>
  ),
});
